import React from 'react';
// import Typed from 'react-typed';
// import { ParticleAnimation } from '../components';
import { Skill } from '../components';
import _ from 'lodash';

const Home = (props) => {
    const { user } = props;

    const renderHomeService = (list) => {
        const items = []
        for (const [index, value] of list.entries()) {
            items.push(<span key={index} className="home-service"><i className="fa fa-check"></i>{value}</span>)
        }
        return items;
    }

    if (_.isEmpty(user)) return false;
    return (
        //  {/* <!-- ========== Start Home ========== --> */}

        <section className="home active area-bg" id="home" style={{ backgroundImage: `url(${user.logImg})` }}>
            <div className="container-fluid home-container row">
                <div className="home-intro d-flex h-100 align-items-center col-lg-12 col-xl-5">
                    <div className="home-info">
                        <h3>Hey, My name is</h3>
                        <h1>{user.name}</h1>
                        <div className="service-block">
                            {renderHomeService(user.role)}
                        </div>
                        {/* <p>
                            {user.title}
                            <Typed
                                strings={user.role || []}
                                typeSpeed={100}
                                backSpeed={50}
                                backDelay={1000}
                                loop
                                smartBackspace
                            />
                        </p> */}

                        {
                            user.guru && (<a href={user.guru} className="main-btn">Hire Me</a>)
                        }
                        {
                            !user.guru && (<a href={`mailto:${user.email}`} className="main-btn">Hire Me</a>)
                        }
                    </div>
                </div>
                <div className="col-lg-12 col-xl-7 home-preview">
                    <Skill />
                    <img src={`images/bk.png`} alt=""></img>

                </div>
            </div>

        </section>

        //    {/* <!-- ========== End Home ========== --> */}
    );
}

export { Home };
